import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {Link} from 'react-router-dom';


export default (props)=>(
  <div className={css.header}>
    <Link className={css.logo} to="/">
      <b>stori</b>.social
    </Link>
    <Link to="/login" className={cn(css.login, css.pinkButton)}>Login</Link>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/header.js